var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurseAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 5.89543 2.89543 5 4 5H20C21.1046 5 22 5.89543 22 7V8.24984C21.8871 8.24975 21.7724 8.27525 21.6646 8.32918L13.0062 12.6584C12.9226 12.7002 12.837 12.7365 12.75 12.7672V11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V12.7672C11.163 12.7365 11.0774 12.7002 10.9938 12.6584L2.33541 8.32918C2.22755 8.27525 2.11291 8.24975 2 8.24984V7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6771 14L22 9.83853V17C22 18.1046 21.1046 19 20 19H4C2.89543 19 2 18.1046 2 17V9.83853L10.3229 14C11.3787 14.5279 12.6213 14.5279 13.6771 14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurseAlt);
export default __webpack_public_path__ + "static/media/purse-alt.606a329f5f6d72aa659b26a06a0a653c.svg";
export { ForwardRef as ReactComponent };